/* eslint-disable react/require-default-props */
import { useLocation } from 'react-router-dom';
import ProSidebar from '../../components/Sidebar/sidebar.component';
import ServicingProvider from '../../components/ServiceProvider/serviceProvider.component';
import Header from '../../components/Header/header.component';
import './precertificationIntake.css';
import { PriorAuthorizationDomainContextProvider } from '../../context/ctxPriorAuthorizationDomain';
import { useInterval } from '../../hooks/useInterval';
import ITokenService from '../../interfaces/ITokenService';
import SSORouter from '../../components/SSORouter/SSORouter.Component';
import PriorAuthRequestForm from '../../components/PriorAuthRequestForm/priorauthrequestform.component';
import { appInsights } from '../../AppInsights';

type AppProps = {
  tokenService: ITokenService,
  delay?: number,
  runtime?: number,
};

const PrecertificationIntake = (props: AppProps) => {
  const location = useLocation();
  const domainObject = location.state?.domainObject;
  const sessionType = location.state?.sessionType;
  const docs = location.state?.docs;

  useInterval(() => {
    console.log('Token Refresh Started...');
    props.tokenService.refreshToken()
      .then(() => {
        console.debug(`Token Refreshed: ${new Date().toLocaleString()}`);
        appInsights.trackTrace({ message: `Token Refreshed: ${new Date().toLocaleString()}` });
      })
      .catch((error) => {
        console.error('Refresh Token error: ', error);
        appInsights.trackException({ exception: error });
      });
  }, props.delay || 900, props.runtime || 36000); // 900, 36000 // Poll Every 15min for 10hrs

  return (
    <PriorAuthorizationDomainContextProvider>
      <div data-testid="App" className="card bg-light">
        <Header tokenService={props.tokenService} sessionType={sessionType} skipSavePriorAuthorization={false} />

        <div className="row">
          <div className="sidenav " id="sidebar">
            <div className="border-0 mt-4">
              <ProSidebar priorAuthDomainHeadObj={domainObject?.priorAuthorizationDomainHeader} />
            </div>
          </div>
        </div>
        <main className="content-wrapper" data-testid="contentwrapper">
          <div className="container pt-4 col-auto" id="true-care-form">
            <h2 className="text-content-default mt-2">Precertification Request</h2>
            <section id="main-upx-form">
              <div className="card mt-4">
                <div className="card-body">
                  <SSORouter
                    priorAuthDomainObj={domainObject}
                    isSummaryPage={false}
                    isDisabledCompleteRequestButton={false}
                  />
                  <div className="row mb-3" id="sp-form">
                    <div className="form-group s-provider mb-0 col-12">
                      <p>
                        Review the Servicing
                        Provider Details included
                        in this prior authorization
                        request. Complete required fields,
                        and review phone number before proceeding to the Requesting Provider  Details.
                      </p>
                      <div className="card mb-3 p-0">
                        <div className="card-header">
                          <div className="service-details" id="sp-details" />
                          <h5 className=" font-weight-medium mb-0 text-left">
                            Servicing Provider Details
                            <span className="font-weight-light">(1 Total)</span>
                          </h5>
                        </div>
                        <div className="card-body">
                          <div className="form-group service-details-1">
                            <div className="card mb-2">
                              <ul className="list-group list-group-flush">
                                <ServicingProvider
                                  priorAuthDomainHeadObj={domainObject?.priorAuthorizationDomainHeader}
                                />
                                <PriorAuthRequestForm
                                  priorAuthDomainObj={domainObject}
                                  uploadedDocs={docs?.errorMessage ? [] : docs?.documentServiceGroups}
                                />
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>
      </div>
    </PriorAuthorizationDomainContextProvider>
  );
};
export default PrecertificationIntake;
